// extracted by mini-css-extract-plugin
module.exports = {"rankedStatsPage":"RankedStatsPage_rankedStatsPage__1wWYM","rankedStatsNav":"RankedStatsPage_rankedStatsNav__8YLgF"};